var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoWhiteblue = function SvgLogoWhiteblue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488 75",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_whiteblue_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 2.8h74.4v74.9H2.8z",
    "data-name": "Rechteck 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_whiteblue_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 2.8h487.8v74.9H2.8z",
    "data-name": "Rechteck 5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_whiteblue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h488v75H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 10"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__b)",
    "data-name": "Gruppe 6",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.7 34.4V3.3a.472.472 0 0 0-.5-.5H46.1a.472.472 0 0 0-.5.5v7.5a.634.634 0 0 0 .5.6 29.02 29.02 0 0 1 23 23 .634.634 0 0 0 .6.5h7.5a.536.536 0 0 0 .5-.5",
    "data-name": "Pfad 15"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__b)",
    "data-name": "Gruppe 7",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.9 34.4V3.3a.472.472 0 0 0-.5-.5h-7.5a.634.634 0 0 0-.6.5c-1.2 10.6-11.5 20.9-23 23a.634.634 0 0 0-.5.6v7.5a.472.472 0 0 0 .5.5h31.1a.472.472 0 0 0 .5-.5",
    "data-name": "Pfad 16"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__b)",
    "data-name": "Gruppe 8",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.9 77.2v-7.5a.634.634 0 0 0-.5-.6c-10.6-1.3-20.9-11.5-23-23a.634.634 0 0 0-.6-.5H3.3a.472.472 0 0 0-.5.5v31.1a.472.472 0 0 0 .5.5h31.1a.472.472 0 0 0 .5-.5",
    "data-name": "Pfad 17"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__b)",
    "data-name": "Gruppe 9",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fa7d19",
    d: "M77.7 53.6v-7.5a.472.472 0 0 0-.5-.5H46.1a.472.472 0 0 0-.5.5v31.1a.472.472 0 0 0 .5.5h7.5a.634.634 0 0 0 .6-.5 29.02 29.02 0 0 1 23-23 .56.56 0 0 0 .5-.6",
    "data-name": "Pfad 18"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 13"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__c)",
    "data-name": "Gruppe 11",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M223.1 55.6c-8 0-9.8-4.9-9.8-15.1s1.9-15.5 9.8-15.5 9.7 5.4 9.7 15.5c0 10.4-1.8 15.1-9.7 15.1m0 5.9c12.8 0 16.7-7 16.7-21 0-13.8-3.8-21.4-16.7-21.4-12.8 0-16.7 7.7-16.7 21.4-.1 13.8 3.8 21 16.7 21m-35 0c8.1 0 13.7-3.9 13.7-12.9 0-7-3.1-9.3-11.7-11.7-7-2-9.2-2.8-9.2-6.6 0-3.5 2.5-5.4 7.6-5.4 2.5 0 8.3.6 11.9 1l.5-5.5a88 88 0 0 0-13-1.4c-8.2 0-13.7 3.5-13.7 11.8 0 7.1 3.8 9.8 12.7 12.1 6.3 1.6 8.2 2.8 8.2 6.2 0 4.3-2.4 6.5-7.4 6.5-3.1 0-8.8-.6-12.4-1l-.7 5.3a96 96 0 0 0 13.5 1.6m-26.9-.7h6.7V19.7h-6.7Zm-12.3-41.1L143 55h-1.3L134 19.8h-7.9L118.3 55H117l-5.9-35.3h-7l8 41.1H123l7-33 7 33h10.8l8.1-41.1Z",
    "data-name": "Pfad 19"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_whiteblue_svg__c)",
    "data-name": "Gruppe 12",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M477.2 55.9c-5.5 0-6.7-3.3-6.7-10.3 0-6.9 1.5-9.9 6.7-9.9 5.3 0 6.7 3 6.7 9.9.1 7-1.1 10.3-6.7 10.3m0 5.6c10.3 0 13.4-5.9 13.4-15.8 0-9.7-3.3-15.5-13.4-15.5-10 0-13.4 5.8-13.4 15.5.1 9.9 3.2 15.8 13.4 15.8m-32.4-.7h6.5V39.9a49 49 0 0 1 10.1-3.1v-6.6a31.7 31.7 0 0 0-10.1 4.2v-3.5h-6.5Zm-22.3.7c3.4 0 5.8-1 8.8-2.5v1.9h6.5v-30h-6.5V54a16.6 16.6 0 0 1-6.8 1.6c-4.6 0-5-2.5-5-9.1V30.8H413v15.7c-.3 9.9 1.5 15 9.5 15m6.1-37.1h6.3v-6.8h-6.3Zm-12.5 0h6.2v-6.8h-6.2ZM384.7 55V42.9h8.9c3.2 0 6.7 1.3 6.7 5.9 0 4.9-2.5 6.2-6.6 6.2zm0-17.8V25.5h8.5c4.1 0 6.1 1.7 6.1 5.7s-1.7 5.9-5.8 5.9h-8.8ZM378 60.8h16.1c8 0 13.1-3.2 13.1-11.6 0-5.6-2.3-8.2-5.8-9.5 3.2-1.8 4.8-4.3 4.8-9.2 0-7.6-4.4-10.7-12.5-10.7H378Zm-32.6 0h6.5V37.6a17.4 17.4 0 0 1 6.8-1.6c4.6 0 5.3 2.9 5.3 8.9v15.9h6.5V44.7c0-9.8-2-14.6-10.4-14.6a18.4 18.4 0 0 0-8.2 2.5v-1.9h-6.5zm-13.7 0h6.5v-30h-6.5Zm0-35h6.5v-7h-6.5Zm-24.4 17.7c.1-5.7 2-8 6.4-8s6.1 2 6.1 8Zm5.9 18a72 72 0 0 0 12.2-1.4l-.1-4.9c-2.7.2-7.6.5-11.1.5-5 0-6.8-2.3-6.8-7.1h18.5l.4-4.7c0-9.4-4.2-13.7-12.6-13.7-8.3 0-13 5-13 16 0 10.5 3.5 15.3 12.5 15.3m-60-.7h6.7V27.2h.9l9.7 32h7l9.7-32h.9v33.7h6.7V19.7h-11.7l-9.1 32-9.1-32h-11.6v41.1Z",
    "data-name": "Pfad 20"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWhiteblue);
export default ForwardRef;